export default __webpack_public_path__ + "static/media/vsetko-oSlovensku.c0d21ed6.svg";